module.exports = "/packs/images/pages/venues/play_mobile~018189a982abcc7ea09bc131ebaa560b.jpg";